import { render } from "./phoneNumber.vue?vue&type=template&id=6a1eb45a&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=js"
export * from "./phoneNumber.vue?vue&type=script&lang=js"

import "./phoneNumber.vue?vue&type=style&index=0&id=6a1eb45a&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1eb45a"]])

export default __exports__